import { FC } from 'react'
import { styled } from '../../../../lib/stitches'
import Button from '../../../core/Button/Button'
import { Column } from '../../../core/Components'
import { ClipboardCheckIcon } from '../../../core/icons/icons'
import { Subtitle } from '../../../core/Subtitle'
import { Title } from '../../../core/Title'
import { gray5 } from '../../../platform/color'
import { FooterContainer, HeaderContainer, SectionHeader } from './MintSoundModalContent'

const GlobalMusicIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5309 1.23819C15.7675 1.00622 16.1474 1.00999 16.3794 1.24662C17.9584 2.85736 18.9331 5.06545 18.9331 7.49998C18.9331 12.2322 15.2536 16.105 10.5994 16.4135V17.7335H11.6661C11.9975 17.7335 12.2661 18.0021 12.2661 18.3335C12.2661 18.6648 11.9975 18.9335 11.6661 18.9335H9.99944H8.33278C8.00141 18.9335 7.73278 18.6648 7.73278 18.3335C7.73278 18.0021 8.00141 17.7335 8.33278 17.7335H9.39944V16.4135C7.20339 16.2677 5.22365 15.3278 3.74638 13.8796C3.50975 13.6477 3.50597 13.2678 3.73795 13.0312C3.96992 12.7945 4.3498 12.7907 4.58643 13.0227C5.98195 14.3908 7.89185 15.2333 9.99974 15.2333C14.2707 15.2333 17.7331 11.771 17.7331 7.49998C17.7331 5.39209 16.8905 3.48219 15.5225 2.08668C15.2905 1.85005 15.2943 1.47017 15.5309 1.23819ZM9.99974 2.26665C7.10945 2.26665 4.76641 4.60969 4.76641 7.49998C4.76641 10.3903 7.10945 12.7333 9.99974 12.7333C12.89 12.7333 15.2331 10.3903 15.2331 7.49998C15.2331 4.60969 12.89 2.26665 9.99974 2.26665ZM3.56641 7.49998C3.56641 3.94695 6.44671 1.06665 9.99974 1.06665C13.5528 1.06665 16.4331 3.94695 16.4331 7.49998C16.4331 11.053 13.5528 13.9333 9.99974 13.9333C6.44671 13.9333 3.56641 11.053 3.56641 7.49998Z"
      fill="#141414"
    />
    <path
      d="M10.9997 8.66659C10.9997 9.40297 10.4027 9.99992 9.66634 9.99992C8.92996 9.99992 8.33301 9.40297 8.33301 8.66659C8.33301 7.93021 8.92996 7.33325 9.66634 7.33325C10.4027 7.33325 10.9997 7.93021 10.9997 8.66659Z"
      stroke="#141414"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9995 8.6665V4.1665L12.3328 5.49984"
      stroke="#141414"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const TermContainer = styled(Column, {
  padding: '24px 0px 12px 0px'
})

interface Props {
  handleMint: () => void
  onCancel: () => void
}
const MintSoundTerms: FC<Props> = ({ handleMint, onCancel }) => (
  <Column css={{ width: '580px' }}>
    <HeaderContainer>
      <Title>{'Terms and Conditions'}</Title>
      <Subtitle css={{ color: gray5 }}>Updated 7/27/22</Subtitle>
    </HeaderContainer>
    <TermContainer>
      <SectionHeader bold>
        <GlobalMusicIcon style={{ marginRight: '10px' }} />
        How it works
      </SectionHeader>

      <Subtitle css={{ lineHeight: '22px' }}>
        On Arpeggi, any sound you hear is a sound you can create with. To make this possible, all
        sounds on Arpeggi are{' '}
        <a
          style={{ textDecoration: 'underline' }}
          target="_blank"
          href="https://creativecommons.org/licenses/by/4.0/"
        >
          CC BY
        </a>
        . In return, we use web3 technology to track when, where, and how your sounds are used by
        other artists so you can encourage the reuse of your sounds.'
      </Subtitle>
    </TermContainer>
    <TermContainer>
      <SectionHeader bold>
        <ClipboardCheckIcon
          height="20px"
          width="20px"
          style={{ fill: '#141414', marginRight: '10px' }}
        />
        Accepting the terms
      </SectionHeader>
      <Subtitle css={{ lineHeight: '22px' }}>
        By clicking 'Mint sounds' you certify that these sounds are yours to upload, that you
        understand that they will be entered into the public domain as{' '}
        <a
          style={{ textDecoration: 'underline' }}
          target="_blank"
          href="https://creativecommons.org/licenses/by/4.0/"
        >
          CC BY
        </a>{' '}
        making them available for use by anyone, and you have read and agreed to the{' '}
        <a
          style={{ textDecoration: 'underline' }}
          target="_blank"
          href="/legal/music-contributor-agreement"
        >
          Music Contributor Agreement
        </a>
        .
      </Subtitle>
    </TermContainer>

    <FooterContainer css={{ justifyContent: 'stretch' }}>
      <Button
        type={'outlined'}
        big={true}
        onClick={onCancel}
        css={{ flex: '1', marginRight: '12px' }}
        modalButton
      >
        Cancel
      </Button>

      <Button type={'dark'} big={true} onClick={handleMint} css={{ flex: '1' }} modalButton>
        Mint Sounds
      </Button>
    </FooterContainer>
  </Column>
)

export default MintSoundTerms
